export { default } from './ShareHistoryTable';
